import React, { useState } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Link, Box } from 'components/ui';
import skuUtils from 'utils/Sku';
import localeUtils from 'utils/LanguageLocale';
import Actions from 'actions/Actions';
import ProductActions from 'actions/ProductActions';
import UrlUtils from 'utils/Url';
import historyLocationActions from 'actions/framework/HistoryLocationActions';
import WizardActions from 'actions/WizardActions';
import skuHelpers from 'utils/skuHelpers';
import ColorIQBadgeEN from 'components/ProductPage/ColorIQBadge/locales/ColorIQBadge_en_US';
import ColorIQBadgeFR from 'components/ProductPage/ColorIQBadge/locales/ColorIQBadge_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(ColorIQBadgeEN, ColorIQBadgeFR);
const { SKU_ID_PARAM } = skuUtils;
const { showColorIQModal } = Actions;

const ColorIQBadge = ({ isColorIQ: isColorIQProp, product, colorIQMatch }) => {
    const dispatch = useDispatch();
    const historyQueryParams = useSelector(state => state.historyLocation.queryParams, shallowEqual);
    const [isColorIQ, setIsColorIQ] = useState(isColorIQProp);
    const [hasShadeCodeParam] = useState(() => UrlUtils.getParamsByName('shade_code'));

    const goToColorIQMatch = e => {
        e.preventDefault();
        const colorIQMatchSku = skuHelpers.getColorIQMatchSku(product.regularChildSkus, colorIQMatch?.skuId);

        if (colorIQMatchSku) {
            dispatch(WizardActions.clearResult());
            dispatch(ProductActions.updateSkuInCurrentProduct(colorIQMatchSku));

            const queryParams = Object.assign({}, historyQueryParams);
            queryParams[SKU_ID_PARAM] = colorIQMatchSku.skuId;
            dispatch(historyLocationActions.goTo({ queryParams }));

            return true;
        }

        return false;
    };

    const colorIQMessage = e => {
        setIsColorIQ(false);
        goToColorIQMatch(e);
    };

    const editColorIQ = e => {
        e.preventDefault();
        dispatch(
            showColorIQModal(true, () => {
                goToColorIQMatch(e);
            })
        );
    };

    return isColorIQ ? (
        <Link
            is='span'
            display='inline'
            padding={2}
            margin={-2}
            onClick={colorIQMessage}
            color='blue'
        >
            {getText('colorIQ')}
        </Link>
    ) : (
        <Box
            marginRight='auto'
            paddingX='.5em'
            paddingY='.125em'
            fontSize='sm'
            lineHeight='tight'
            backgroundColor='nearWhite'
            borderRadius={2}
        >
            {getText('your')}
            {hasShadeCodeParam || (
                <React.Fragment>
                    {' '}
                    <Link
                        is='span'
                        display='inline'
                        padding={2}
                        margin={-2}
                        onClick={editColorIQ}
                        color='blue'
                    >
                        {getText('colorIQMatch', false)}
                    </Link>
                </React.Fragment>
            )}
        </Box>
    );
};

export default wrapFunctionalComponent(ColorIQBadge, 'ColorIQBadge');
